import React from 'react';
import '../../style/formGroupTextInput.css'

const CustomTextInput = (props) => {
    return (
        <div className={props.wrapper}>
            <input
                type={props.Type}
                step={props.step}
                max={props.max}
                min={props.min}
                disabled={props.Disabled}
                required={props.Required}
                className="form-control formGroup-textInput-input"
                placeholder={props.Placeholder}
                name={props.Name}
                value={props.Value}
                onChange={props.HandleInputChange}
            />
        </div>
    )
};

export default CustomTextInput;